export enum Title {
	Dr = 'Dr',
	Miss = 'Miss',
	Mr = 'Mr',
	Mrs = 'Mrs',
	Ms = 'Ms',
	Mx = 'Mx',
	Rev = 'Rev',
	Other = 'Other'
}
